import { Box, Spinner, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";

import Asesor from "@/sections/asesores/Asesor";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const LayoutAsesor = () => {
    const router = useRouter();
    const id = router.query.id;

    return (
        <>
            <Head>
                <title> Asesores | Grupo Guía </title>
            </Head>
            <Header />

            <Box pt={20} mt={16} pb={20} justifyItems="center">
                {id ? (
                    <Asesor id={id} />
                ) : !id ? (
                    <Stack maxW="7xl" margin="auto" textAlign="center" alignItems="left">
                        <Text fontSize="xl">Lo sentimos, el usuario no fue encontrado.</Text>
                    </Stack>
                ) : (
                    <Stack maxW="7xl" margin="auto" textAlign="center" alignItems="center">
                        <Spinner
                            borderWidth="4px"
                            animationDuration="0.65s"
                            emptyColor="gray.200"
                            color="yellow.300"
                            size="lg"
                        />
                        <Text>Estamos cargando la información, por favor, espera ...</Text>
                    </Stack>
                )}
            </Box>

            {/* Footer Section */}
            <Box>
                <Footer esGuiaRent={false} />
            </Box>
        </>
    );
};

export default LayoutAsesor;
